/**
 * A teammate's round photo, or their initials when there is none. The photo
 * is fetched with the sign-in token; each version is fetched once per page
 * load (the version changes with every new photo).
 */
import { useEffect, useState } from 'react';
import { ts } from './api';

const cache = new Map(); // `${id}:${version}` -> Promise<object URL | null>

function photoUrl(id, version) {
  const key = `${id}:${version}`;
  if (!cache.has(key)) {
    cache.set(key, ts.photoBlob(id, version).then(b => URL.createObjectURL(b)).catch(() => null));
  }
  return cache.get(key);
}

export function initials(name) {
  const s = (name || '').trim().split(/\s+/).filter(Boolean).slice(0, 2).map(w => w[0].toUpperCase()).join('');
  return s || '?';
}

export default function Avatar({ id, name, version, size = 36 }) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let live = true;
    setSrc(null);
    if (id && version) photoUrl(id, version).then(u => { if (live) setSrc(u); });
    return () => { live = false; };
  }, [id, version]);
  const box = { width: size, height: size, fontSize: Math.round(size * 0.38) };
  return src
    ? <img src={src} alt={name || ''} style={box} className="rounded-full object-cover shrink-0" data-testid={`ts-avatar-${id}`} />
    : <div style={box} aria-label={name || ''} className="rounded-full shrink-0 bg-emerald-500/15 text-emerald-700 dark:text-emerald-300 font-bold flex items-center justify-center">{initials(name)}</div>;
}
